export const themeBase = {
  spacing: {
    xs: 8,
    s: 14,
    m: 16,
    l: 18,
    xl: 24,
  },
  fontSize: {
    messageFontSize: 14,
    headerFontSize: 16,
  },
  borderRadius: {
    regular: 14,
    rounded: 28,
  },
  bgColor: {
    regular: '#FFFFFF',
    dark: '#2D2D2D',
  },
  fontColor: {
    regular: '#505050',
    dark: '#FAFAFA',
  },
  color: {
    success: '#00EA33',
    error: '#FC6060',
    info: '#8CACFF',
    warning: '#FFD37D',
    darkGray: '#767676',
    lightGray: '#CACACA',
    shadow: '#A1A1A140',
  },
}
